var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-button',{class:_vm.$style.container,attrs:{"size":"md"},on:{"click":_vm.onShare}},[_c('icon',{attrs:{"name":"share","width":"14","height":"12"}}),_vm._v(" "+_vm._s(_vm.$t('share'))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }